// ------------------------------------------
// よくあるご質問の開閉状態(aria-expanded)
// 開閉アニメーションはテンプレートの Accordion.js
// ------------------------------------------
class FaqAccordion {
  constructor(el, opt) {
    this.btns = document.querySelectorAll('.' + el);
    if (this.btns.length > 0) {
      this.event();
    }
  }
  event() {
    this.btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }
}
